const redMain = '#d40c24';

export default () => ({

	// styles
	sectionFull: {
		backgroundColor: '#FFF',
		width: '100%',
	},
	container: {
		backgroundColor: '#ddd',
		display: 'flex',
		height: '90vh',
		justifyContent: 'space-between',
		width: '100%',
	},
	title: {
		fontFamily: 'Ultra System Sans',
		fontSize: '24px',
	},
	p: {
		fontFamily: 'Graphik',
		fontSize: '14px',
	},
	btn: {
		backgroundColor: redMain,
		border: 'none',
		color: '#FFF',
		cursor: 'pointer',
		fontFamily: 'Graphik',
		fontSize: '14px',
		margin: '25px',
		padding: '15px 50px',
	},
	main: {
		alignItems: 'center',
		height: '90vh',
		backgroundColor: '#FFF',
	},
	inputs: {
		border: 'none',
		margin: '10px 0px',
		height: '24px',
		width: '100%',
		borderBottom: '1px solid #D2D2D3',
		outline: 'none',
	},
	red: {
		color: redMain,
		fontWeight: 500,
		textDecoration: 'blink',
		'&:hover': {
			cursor: 'pointer',
		},
	},
	actions: {
		fontFamily: 'Graphik',
		fontSize: '12px',
	},
	required: {
		textAlign: 'right',
		fontFamily: 'Graphik',
		fontSize: '14px',
		color: '#909090',
		marginBottom: '-50px',
	},
	label: {
		color: '#909090',
		display: 'inline-block',
		fontFamily: 'Graphik',
		fontSize: '12px',
		width: '100%',
		textAlign: 'left',
	},
	divInputs: {
		width: '35%',
	},
});
